import { gql } from 'urql';

const GetContactUsPageTiles = gql`
  query GetContactUsPageTiles($input: ContactUsPageTileInput!) {
    contactUsPageTile(input: $input) {
      __typename
      id
      tileType
      tiles {
        ... on ContactUsTile {
          __typename
          id
          tileType
          title
          message
        }
        ... on ChatTile {
          __typename
          id
          tileType
          title
          message
          isChatOnline
          ctaCopy
        }
      }
    }
  }
`;

export default GetContactUsPageTiles;
